<template>
  <div v-click-outside="clickOutside" class="relative w-full" ref="list"
       :class="[{ 'z-modal' : listOpen && isDesktop }, options.length <= 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer']">
    <div @click="toggleList"
         :style="{height: `${height}px`, paddingLeft: `${padding}px`}"
         class="w-full text-[13px] pl-[6px] pr-4 rounded-zt flex justify-between items-center border border-zt-light
                bg-zt-light/35">
      <Transition name="fade" mode="out-in">
        <div :key="selected" class="flex items-center gap-x-[6px]">
          <span class="text-xs">{{ isModelObject ? selected.string : selected }}</span>
        </div>
      </Transition>
      <svg :class="[{ 'rotate-180' : listOpen }, {'hidden' : options.length <= 1}]"
           class="transition"
           width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.99875 0.083984L4.25 3.32815L7.50125 0.0839843L8.5 1.08273L4.25 5.33273L1.94762e-07 1.08273L0.99875 0.083984Z"
              fill="white"/>
      </svg>
    </div>
    <template v-if="isDesktop">
      <Transition name="fade">
        <div v-if="listOpen"
             :style="{ top : `${44 + (height - 38)}px` }"
             class="bg-[#283344] w-full max-h-[316px] overflow-y-auto absolute z-10  rounded-zt border border-zt-light
                    shadow-zt xl:max-h-[304px]">
          <div v-for="(option, index) in options"
               :key="option" @click="selectOption(option)"
               :class="{ '!border-b-0' : index === options.length - 1,
                         '!bg-zt-light hover:!bg-zt-light' : option === selected || option === selected?.string }"
               class="hover:bg-zt-light/35 bg-[#283344] cursor-pointer pl-[6px] result no-default-style text-[13px]
                      border-zt-light py-2 h-[38px] border-b-[1px] flex items-center gap-x-[6px]">
            <p class="name font-normal">{{ option }}</p>
          </div>
        </div>
      </Transition>
    </template>
    <template v-else-if="listOpen">
      <SuperbetsSelectMobile @changed-option="selectOption"
                             @close-modal="listOpen = false"
                             :options="options"
                             :selected-option="selected"/>
    </template>
  </div>
</template>

<script>
import SuperbetsSelectMobile from "./football_stats/blocks/SuperbetsSelectMobile.vue";

export default {
  name: 'FootballSelect',
  components: { SuperbetsSelectMobile },
  emits: ['listOpen'],
  props: {
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      required: true,
    },
    default: {
      type: String,
      default: null,
    },
    isModelObject: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 38
    },
    padding: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      listOpen: false,
      selected: this.modelValue
    };
  },
  mounted() {
    if (!this.default) {
      return;
    }
    if (this.isModelObject) {
      this.selected.string = this.default;
    } else {
      this.selected = this.default;
    }
  },
  computed: {
    isDesktop() {
      return window.size.desktop;
    }
  },
  watch: {
    listOpen(newValue) {
      this.$emit('listOpen', newValue);
    }
  },
  methods: {
    toggleList() {
      this.listOpen = !this.listOpen;
    },
    selectOption(option) {
      if (this.isModelObject) {
        this.selected.string = option;
      } else {
        this.selected = option;
      }
      this.$emit('update:modelValue', this.selected);
      this.listOpen = false;
    },
    clickOutside() {
      this.listOpen = false;
    }
  }
};
</script>
